import { MenuItem } from '@/types';

/**
 * 路由/按钮权限枚举key
 */
export enum RouteAuthorityKey {
  /**
   * 查询功能
   */
  Search = '/search',
  /**
   * 查工商
   */
  Business = '/search/business/:recordNo?',
  /**
   * 个人诉讼
   */
  Lawsuit = '/search/lawsuit/:recordNo?',
  /**
   * 企业诉讼
   */
  EnterpriseLawsuit = '/search/enterpriseLawsuit/:recordNo?',
  /**
   * 大数据
   */
  BigData = '/search/bigdata/:recordNo?',
  /**
   * 广东社保
   */
  SocialSecurity = '/search/socialSecurity/:recordNo?',
  /**
   * 婚姻状况：
   */
  Marital = '/search/marital/:recordNo?',
  /**
   * 历史成交
   */
  HistoricalTransaction = '/search/historicalTransaction/:recordNo?',
  /**
   * 名下房产
   */
  RealEstate = '/search/realEstate/:recordNo?',
  /**
   * 自定义查
   */
  DiySearch = '/search/diySearch',
  /**
   * 房产评估
   */
  RealEstateAssessment = '/search/realEstateAssessment/:recordNo?',
  /**
   * 学历信息
   */
  // EducationInfo = "/search/education/:recordNo?",
  /**
   * 实名核验
   */
  Verification = '/search/verification',
  /**
   * 三要素核验
   */
  verificationThree = '/search/verification/three',
  /**
   * 四要素核验
   */
  VerificationFour = '/search/verification/four',
  /**
   * 查车辆
   */
  CarSearch = '/search/carSearch',
  /**
   * 名下车辆
   */
  MyCar = '/search/carSearch/myCar',
  /**
   * 过户次数
   */
  TransferNum = '/search/carSearch/transferNum',
  /**
   * 人/企车主核验
   */
  OwnerVerification = '/search/carSearch/ownerVerification',
  /**
   * 二手车精准评估
   */
  UsedCar = '/search/carSearch/usedCar',
  /**
   * 车五项查询
   */
  CarFiveItems = '/search/carSearch/carFiveItems',
  /**
   * 行驶证查询
   */
  DrivingPermit = '/search/carSearch/drivingPermit',
  /**
   * 车辆保险查询
   */
  CarInsurance = '/search/carSearch/carInsurance',
  /**
   * 出险详情记录
   */
  AccidentRecords = '/search/carSearch/accidentRecords',
  /**
   * 客户档案
   */
  CustomerProfile = '/customerProfile',
  /**
   * 个人中心
   */
  UserCenter = '/userCenter',
  /**
   * 用户管理
   */
  UserManage = '/userCenter/userManage',
  /**
   * 角色管理
   */
  RoleManage = '/userCenter/role-manage',
  /**
   * 查询记录
   */
  SearchHistory = '/userCenter/search-history',
  /**
   * 隐私协议
   */
  Agreement = '/userCenter/agreement',
  /**
   * 账户钱包
   */
  Wallet = '/userCenter/wallet',
  /**
   * 设置
   */
  UserCenterSetting = '/userCenter/setting',
  /**
   * 消息列表
   */
  UserCenterMessage = '/userCenter/message',
  /**
   * 新增用户
   */
  UserAdd = '/userCenter/userManage/add',
  /**
   * 编辑用户
   */
  UserUpdate = '/userCenter/userManage/update',
  /**
   * 删除用户
   */
  UserDel = '/userCenter/userManage/del',
  /**
   * 登录权限切换
   */
  UserSwitchAuth = '/userCenter/userManage/switchAuth',
  /**
   * 角色管理-新增角色
   */
  RoleAdd = '/userCenter/roleManage/add',
  /**
   * 角色管理-修改权限
   */
  RoleUpdateAuth = '/userCenter/roleManage/updateAuth',
  /**
   * 角色管理-添加用户
   */
  RoleUserAdd = '/userCenter/roleManage/addUser',
  /**
   * 重命名
   */
  RoleRename = '/userCenter/roleManage/rename',
  /**
   * 复制角色
   */
  RoleCopy = '/userCenter/roleManage/copy',
  /**
   * 删除角色
   */
  RoleDel = '/userCenter/roleManage/del',
  /**
   * 查询记录-看全局
   */
  SearchHistoryGlobal = '/userCenter/searchHistory/global',
  /**
   * 账户钱包-充值
   */
  WalletRecharge = '/userCenter/wallet/recharge',
  /**
   * 账户钱包-申请发票
   */
  WalletInvoiceRequest = '/userCenter/wallet/invoiceRequest',
  /**
   * 账户钱包-下载发票
   */
  WalletInvoiceDownload = '/userCenter/wallet/downloadInvoice',
  /**
   * 设置-个人信息
   */
  SettingUserInfo = '/setting/userInfo',
  /**
   * 设置-企业信息
   */
  SettinGenterpriseInfo = '/setting/enterpriseInfo',
  /**
   * 查询记录-看自己
   */
  SearchHistorySelf = '/userCenter/searchHistory/self',
  /**
   * 查询功能-企业税票
   */
  EnterpriseTaxInvoice = '/search/enterpriseTaxInvoice',
  /**
   * 安全中心-授权记录
   */
  AuthRecord = '/userCenter/security/authRecord',
  /**
   * 安全中心-登录日志
   */
  LoginRecord = '/userCenter/security/loginRecord',
  /**
   * 个人中心-安全中心
   */
  UserCenterSecurity = '/userCenter/security',
  /**
   * 安全中心—授权记录—打开授权
   */
  OpenAuth = '/authRecord/openAuth',
  /**
   * 安全中心—授权记录—重新授权
   */
  Reauthorize = '/authRecord/Reauthorize',
  /**
   * 安全中心—授权记录—查看报告
   */
  ViewReport = '/authRecord/Report',
  /**
   * 个人中心—设置—个人信息—更改头像
   */
  ChangeAvatar = '/setting/userInfo/avatar',
  /**
   * 个人中心—设置—个人信息—更改个人昵称
   */
  ChangeNickname = '/setting/userInfo/nickname',
  /**
   * 个人中心—设置—个人信息—重置密码
   */
  ResetPassword = '/setting/userInfo/password',
  /**
   * 个人中心—设置—系统信息—更改头像
   */
  ChangeErAvatar = '/setting/enterpriseInfo/avatar',
  /**
   * 个人中心—设置—系统信息—更改系统名称
   */
  ChangeErName = '/setting/enterpriseInfo/name',
  /**
   * 账户钱包—查看消费价目表
   */
  ConsumerPrice = '/wallet/consumerPrice',
  /**
   * 产品中心
   */
  ProductCenter = '/productCenter',
  /**
   * 产品中心—字典管理
   */
  DictionaryManagement = '/productCenter/dictionaryManagement',
  /**
   * 产品中心—规则库管理
   */
  RuleLibraryManagement = '/productCenter/ruleLibraryManagement',
  /**
   * 产品中心—模版中心
   */
  TemplateCenter = '/productCenter/templateCenter',
  /**
   * 产品中心—模版中心-模版设计器
   */
  TemplateDesigner = '/productCenter/templateDesigner',
  /**
   * 产品中心—产品中心
   */
  ProductManagement = '/productCenter/productManagement',
  /**
   * 产品中心—产品中心-产品设计器
   */
  ProductDesigner = '/productCenter/productDesigner',
  /**
   * 产品中心—客户匹配
   */
  CustomerMatching = '/productCenter/customerMatching',
  /**
   * 产品中心—仿真测试
   */
  SimulationTest = '/productCenter/simulationTest',
  /**
   * 产品中心—配置交换
   */
  ConfigurationExchange = '/productCenter/configurationExchange',
}

/**
 * 动态路由需要展示企业搜索组件的路由key数组
 */
export const showEnterpriseSearchs: RouteAuthorityKey[] = [RouteAuthorityKey.Business];

/**
 * 嵌套路由
 */
export const nestedPatterns: RouteAuthorityKey[] = [
];

/**
 * 动态路由需要展示面包屑组件的路由key数组
 */
export const showBreadcrumbs = [
  RouteAuthorityKey.Business,
  RouteAuthorityKey.Lawsuit,
  RouteAuthorityKey.EnterpriseLawsuit,
  RouteAuthorityKey.RealEstateAssessment,
  RouteAuthorityKey.HistoricalTransaction,
  RouteAuthorityKey.Marital,
  RouteAuthorityKey.Verification,
  RouteAuthorityKey.RealEstate,
  RouteAuthorityKey.SocialSecurity,
  RouteAuthorityKey.DiySearch,
  RouteAuthorityKey.CarSearch,
  RouteAuthorityKey.WalletRecharge,
  RouteAuthorityKey.EnterpriseTaxInvoice,
  RouteAuthorityKey.ProductDesigner,
  RouteAuthorityKey.TemplateDesigner,
];

/**
 * 动态路由需要开启keepAlive的路由key数组
 */
export const keepAlives = [
  RouteAuthorityKey.Business,
  RouteAuthorityKey.Lawsuit,
  RouteAuthorityKey.EnterpriseLawsuit,
  RouteAuthorityKey.SearchHistory,
  RouteAuthorityKey.DiySearch,
  RouteAuthorityKey.Wallet,
  RouteAuthorityKey.UserCenterSecurity,
  RouteAuthorityKey.UserCenterMessage,
];

/**
 * 详情页面路由配置，用于动态生成详情页面的面包屑和菜单项
 */
export const staticDetailRoute: MenuItem[] = [];

// 协议页面URl
export const protocolList: string[] = [
  '/protocol/user', // 用户协议
  '/protocol/privacy', // 隐私协议
  '/protocol/autoRenewal', // 自动续费协议
];
